export { default } from './MyImage';
